var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse2, _path11, _path12, _g, _path13, _circle, _circle2, _circle3, _ellipse3, _path14, _ellipse4, _ellipse5, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 171,
    height: 104,
    viewBox: "0 0 171 104",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.1452,
    cy: 11.3377,
    rx: 85.1452,
    ry: 11.3377,
    transform: "matrix(-1 0 0 1 170.29 79.9264)",
    fill: "#FFC2A2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.4669 0.970947L152.937 7.95375L132.364 13.2096L69.8939 6.22682L90.4669 0.970947Z",
    fill: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.894 6.74928C69.894 6.39055 70.206 6.11153 70.5625 6.15138L131.829 12.9997C132.134 13.0337 132.364 13.2912 132.364 13.5976L132.364 91.225C132.364 91.5837 132.052 91.8627 131.695 91.8229L70.4288 84.9746C70.1243 84.9405 69.894 84.6831 69.894 84.3767L69.894 6.74928Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.111 13.4695C130.111 13.1864 130.309 12.9416 130.586 12.8816L152.583 8.11183C152.958 8.03054 153.312 8.31617 153.312 8.69979L153.312 86.3067C153.312 86.5899 153.115 86.8347 152.838 86.8947L130.841 91.6644C130.466 91.7457 130.111 91.4601 130.111 91.0764L130.111 13.4695Z",
    fill: "#B3B3B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6993 21.4302C74.6993 20.8912 75.1687 20.4724 75.7042 20.5336L119.926 25.5833C120.382 25.6354 120.726 26.0212 120.726 26.48L120.726 79.3995C120.726 79.9385 120.256 80.3573 119.721 80.2961L75.4994 75.2464C75.0436 75.1943 74.6993 74.8085 74.6993 74.3498L74.6993 21.4302Z",
    fill: "#B3B3B3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5524 24.5056C77.5524 23.9673 78.0206 23.5487 78.5556 23.6088L116.846 27.9111C117.302 27.9624 117.647 28.3484 117.647 28.8079L117.647 76.0965C117.647 76.6348 117.179 77.0534 116.644 76.9933L78.354 72.6911C77.8975 72.6398 77.5524 72.2537 77.5524 71.7943L77.5524 24.5056Z",
    fill: "#808080"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4124 50.2418C86.4124 44.6792 91.2512 40.3537 96.779 40.9749L116.846 43.2299C117.302 43.2812 117.647 43.6673 117.647 44.1267L117.647 76.0965C117.647 76.6348 117.179 77.0534 116.644 76.9933L87.214 73.6861C86.7575 73.6348 86.4124 73.2487 86.4124 72.7893L86.4124 50.2418Z",
    fill: "#2B2B2B",
    fillOpacity: 0.75
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5526 24.3121C77.5526 23.8488 77.2017 23.4607 76.7407 23.4142L19.7549 17.6658C19.2233 17.6122 18.7618 18.0295 18.7618 18.5637L18.7618 65.8546C18.7618 66.3179 19.1127 66.706 19.5737 66.7525L76.5595 72.5009C77.0911 72.5545 77.5526 72.1372 77.5526 71.603L77.5526 24.3121Z",
    fill: "#B3B3B3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5449 83.2307C35.7154 81.9984 36.8526 81.1376 38.0849 81.3082C44.3241 82.1714 49.2801 84.1084 52.5363 86.2858C54.1466 87.3626 55.4664 88.5819 56.2667 89.8769C57.0475 91.1402 57.5914 92.979 56.5132 94.6706C55.5328 96.2089 53.7115 96.7675 52.0206 96.9227C50.2232 97.0876 47.9414 96.8652 45.1964 96.2419C40.5614 95.1894 34.2883 92.9191 26.1907 88.9445L27.6139 93.5342C27.9823 94.7224 27.3177 95.9844 26.1295 96.3528C24.9413 96.7212 23.6794 96.0567 23.3109 94.8685L20.3076 85.1826C20.0377 84.3123 20.3188 83.3651 21.0197 82.7828C21.7207 82.2005 22.7034 82.098 23.5095 82.5229C33.7798 87.9371 41.2156 90.7183 46.194 91.8487C48.6931 92.4162 50.4623 92.5417 51.609 92.4365C52.0056 92.4001 52.2783 92.3422 52.4606 92.2882C52.4524 92.2744 52.4437 92.2602 52.4346 92.2454C52.0964 91.6982 51.3431 90.9073 50.0322 90.0307C47.4459 88.3013 43.1666 86.5592 37.4674 85.7707C36.2351 85.6002 35.3744 84.463 35.5449 83.2307ZM52.6119 92.6207C52.6104 92.6201 52.6067 92.6079 52.6054 92.5858C52.6127 92.6102 52.6133 92.6213 52.6119 92.6207Z",
    fill: "#FF7E3B",
    stroke: "#9E2F00",
    strokeWidth: 1.50407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6174 83.0535C49.8857 81.8388 51.088 81.0715 52.3027 81.3399C59.9671 83.0329 65.5724 85.5229 68.98 88.1587C70.6664 89.4631 71.9863 90.9359 72.6219 92.5303C73.3066 94.2479 73.1776 96.1391 71.8692 97.648C70.7011 98.9952 68.8733 99.7011 66.8821 100.016C64.8354 100.339 62.2974 100.302 59.3158 99.8757C54.3521 99.1663 47.9419 97.3469 40.1107 94.0233L42.0646 99.272C42.4986 100.438 41.9053 101.735 40.7394 102.169C39.5736 102.603 38.2766 102.01 37.8426 100.844L34.0133 90.5572C33.694 89.6994 33.9255 88.7337 34.5989 88.1139C35.2724 87.4941 36.254 87.3434 37.0823 87.7327C46.941 92.3656 54.5633 94.6456 59.9532 95.416C62.6522 95.8017 64.7133 95.7974 66.1792 95.5658C67.7007 95.3255 68.299 94.8888 68.4655 94.6967C68.468 94.6939 68.4712 94.6909 68.4749 94.6875C68.5107 94.6547 68.59 94.5821 68.4371 94.1985C68.2192 93.6518 67.5889 92.7781 66.2237 91.7221C63.5279 89.637 58.6233 87.3497 51.331 85.7389C50.1162 85.4705 49.349 84.2683 49.6174 83.0535Z",
    fill: "#FF7E3B",
    stroke: "#9E2F00",
    strokeWidth: 1.50407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3353 36.8514C35.4225 36.2466 36.794 36.6376 37.3988 37.7247C43.3687 48.4557 52.4477 52.5609 61.5182 53.3783C70.7 54.2058 79.8249 51.6391 85.3745 49.0152C86.4992 48.4835 87.842 48.9642 88.3737 50.0888C88.9055 51.2135 88.4248 52.5563 87.3001 53.088C81.2105 55.9672 71.2778 58.7811 61.1138 57.8651C50.8386 56.9391 40.2836 52.1769 33.462 39.9149C32.8572 38.8278 33.2482 37.4562 34.3353 36.8514Z",
    fill: "#FF7E3B",
    stroke: "#9E2F00",
    strokeWidth: 1.50407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.4974,
    cy: 36.4667,
    rx: 6.23197,
    ry: 7.73365,
    transform: "rotate(17.4417 76.4974 36.4667)",
    fill: "#FF7E3B",
    stroke: "#9E2F00",
    strokeWidth: 1.50407
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1899 23.7525C35.8043 15.4314 44.6692 10.8051 52.9902 13.4194L69.5608 18.6256C77.8819 21.2399 82.5082 30.1048 79.8939 38.4259L67.171 78.9215C64.5567 87.2426 55.6918 91.8688 47.3707 89.2545L30.8001 84.0484C22.479 81.434 17.8527 72.5691 20.467 64.2481L33.1899 23.7525Z",
    fill: "#FFC2A2",
    stroke: "#9E2F00",
    strokeWidth: 1.50407,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1659_15982",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 16,
    width: 63,
    height: 75
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8397 28.0504C34.454 19.7293 43.3189 15.1031 51.64 17.7174L68.2106 22.9236C76.5317 25.5379 81.158 34.4028 78.5436 42.7238L67.1711 78.9216C64.5567 87.2426 55.6919 91.8689 47.3708 89.2546L30.8002 84.0484C22.4791 81.4341 17.8528 72.5692 20.4671 64.2481L31.8397 28.0504Z",
    fill: "#AFE8C2",
    stroke: "#149A53",
    strokeWidth: 1.50407,
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1659_15982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8052 79.3373L62.3658 93.9657",
    stroke: "#9E2F00",
    strokeWidth: 1.50407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.142 55.9852L69.7026 70.6136",
    stroke: "#9E2F00",
    strokeWidth: 1.50407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2358 71.601L64.7965 86.2294",
    stroke: "#FF9F6C",
    strokeWidth: 1.50407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7115 63.7214L67.2722 78.3498",
    stroke: "#FF9F6C",
    strokeWidth: 1.50407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.142 55.9852L69.7026 70.6136",
    stroke: "#FF9F6C",
    strokeWidth: 1.50407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5726 48.249L72.1333 62.8774",
    stroke: "#FF9F6C",
    strokeWidth: 1.50407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.048 40.3695L74.6086 54.9979",
    stroke: "#FF9F6C",
    strokeWidth: 1.50407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3844 32.6825L15.756 79.2431",
    stroke: "#9E2F00",
    strokeWidth: 1.50407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6675 42.9209L23.4696 81.7453",
    stroke: "#FF9F6C",
    strokeWidth: 1.50407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5471 45.3965L31.3493 84.2209",
    stroke: "#FF9F6C",
    strokeWidth: 1.50407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2833 47.827L39.0855 86.6514",
    stroke: "#FF9F6C",
    strokeWidth: 1.50407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0194 50.2576L46.8216 89.082",
    stroke: "#FF9F6C",
    strokeWidth: 1.50407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8989 52.7333L54.7011 91.5577",
    stroke: "#FF9F6C",
    strokeWidth: 1.50407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0884 47.356L62.46 93.9166",
    stroke: "#9E2F00",
    strokeWidth: 1.50407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8052 79.3373L62.3658 93.9657",
    stroke: "#9E2F00",
    strokeWidth: 1.50407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.592,
    y: 45.2533,
    width: 8.10906,
    height: 40.8457,
    transform: "rotate(17.4417 43.592 45.2533)",
    fill: "#FF7E3B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3773,
    y: 63.4427,
    width: 8.10906,
    height: 24.3272,
    transform: "rotate(17.4417 46.3773 63.4427)",
    fill: "#FF7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7279 73.4662L59.4641 75.8968L54.603 91.3692L46.8668 88.9386L51.7279 73.4662Z",
    fill: "#FF7E3B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8497,
    y: 68.304,
    width: 7.50839,
    height: 24.3272,
    transform: "rotate(17.4417 61.8497 68.304)",
    fill: "#FF7E3B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.4742,
    y: 66.3179,
    width: 8.10906,
    height: 16.2181,
    transform: "rotate(17.4417 28.4742 66.3179)",
    fill: "#FF7E3B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.2172,
    y: 48.4515,
    width: 7.50839,
    height: 32.5864,
    transform: "rotate(17.4417 26.2172 48.4515)",
    fill: "#FF7E3B"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1899 23.7525C35.8043 15.4314 44.6692 10.8051 52.9902 13.4194L69.5608 18.6256C77.8819 21.2399 82.5082 30.1048 79.8939 38.4259L67.171 78.9215C64.5566 87.2426 55.6918 91.8688 47.3707 89.2545L30.8001 84.0484C22.479 81.434 17.8527 72.5692 20.467 64.2481L33.1899 23.7525Z",
    stroke: "#9E2F00",
    strokeWidth: 1.50407,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.8937,
    cy: 29.3956,
    r: 5.08405,
    transform: "rotate(17.4417 60.8937 29.3956)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.0537,
    cy: 33.2161,
    r: 5.08405,
    transform: "rotate(17.4417 73.0537 33.2161)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.2135,
    cy: 30.7775,
    r: 2.40269,
    transform: "rotate(17.4417 62.2135 30.7775)",
    fill: "#9E2F00"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.6492,
    cy: 34.7834,
    rx: 2.40269,
    ry: 2.19674,
    transform: "rotate(17.4417 74.6492 34.7834)",
    fill: "#9E2F00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2224 37.637C81.5438 34.5195 80.4331 31.3018 80.4885 27.9456C80.544 24.5895 79.9412 21.3047 78.7208 18.3125C77.5004 15.3203 75.6908 12.6902 73.4136 10.5993C71.1365 8.50842 68.4448 7.00525 65.5199 6.19105C62.5949 5.37685 59.5046 5.27052 56.457 5.87923C53.4095 6.48794 50.4754 7.79756 47.8524 9.71988C45.2295 11.6422 42.9785 14.1326 41.2511 17.0233C39.5237 19.9141 38.3601 23.1381 37.8385 26.4782L41.086 26.8657C41.5276 24.038 42.5127 21.3086 43.9751 18.8612C45.4375 16.4139 47.3432 14.3056 49.5638 12.6781C51.7844 11.0507 54.2684 9.94197 56.8485 9.42663C59.4286 8.91129 62.0449 9.00131 64.5211 9.69061C66.9974 10.3799 69.2762 11.6525 71.204 13.4227C73.1318 15.1928 74.6639 17.4195 75.6971 19.9527C76.7303 22.4858 79.6979 24.8411 79.6509 27.6825C80.658 30.5173 81.4203 34.8034 80.3016 37.4427L80.2224 37.637Z",
    fill: "#FF7E3B",
    stroke: "#9E2F00",
    strokeWidth: 1.58376
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.1058,
    cy: 24.719,
    rx: 6.23197,
    ry: 7.73365,
    transform: "rotate(17.4417 39.1058 24.719)",
    fill: "#FF7E3B",
    stroke: "#9E2F00",
    strokeWidth: 1.50407
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.7448,
    cy: 24.2914,
    rx: 4.80537,
    ry: 5.93163,
    transform: "rotate(17.4417 37.7448 24.2914)",
    fill: "#FF7E3B",
    stroke: "#9E2F00",
    strokeWidth: 1.50407
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.874 39.4067L103.453 43.486L106.412 45.242L108.852 41.1304C110.271 42.781 110.553 45.2161 109.38 47.1914C108.334 48.9541 106.412 49.8755 104.498 49.7303L97.4175 61.6596C98.4618 63.2704 98.5736 65.3991 97.5274 67.1617C96.355 69.137 94.0825 70.0559 91.954 69.6011L94.5589 65.2123L91.6003 63.4563L89.0145 67.8129C87.6594 66.1646 87.4073 63.7798 88.5593 61.8389C89.6055 60.0762 91.5277 59.1548 93.4419 59.3L100.522 47.3708C99.4779 45.76 99.366 43.6313 100.412 41.8686C101.564 39.9277 103.778 39.0067 105.874 39.4067Z",
    fill: "#B3B3B3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M105.874 39.4067L106.521 39.7905C106.646 39.5798 106.661 39.3213 106.56 39.0978C106.459 38.8743 106.256 38.7139 106.015 38.668L105.874 39.4067ZM103.453 43.486L102.806 43.1021C102.594 43.4593 102.712 43.9207 103.069 44.1327L103.453 43.486ZM106.412 45.242L106.028 45.8887C106.385 46.1006 106.846 45.983 107.058 45.6258L106.412 45.242ZM108.852 41.1304L109.422 40.6402C109.264 40.4565 109.028 40.3601 108.786 40.3812C108.545 40.4023 108.329 40.5383 108.205 40.7466L108.852 41.1304ZM104.498 49.7303L104.555 48.9805C104.27 48.9588 103.997 49.1007 103.851 49.3465L104.498 49.7303ZM97.4175 61.6596L96.7708 61.2758C96.6249 61.5216 96.6309 61.8289 96.7864 62.0687L97.4175 61.6596ZM91.954 69.6011L91.3073 69.2173C91.1837 69.4255 91.1679 69.6806 91.265 69.9025C91.362 70.1243 91.56 70.2859 91.7968 70.3365L91.954 69.6011ZM94.5589 65.2123L95.2056 65.5961C95.4176 65.2389 95.2999 64.7775 94.9427 64.5656L94.5589 65.2123ZM91.6003 63.4563L91.9841 62.8096C91.8126 62.7078 91.6077 62.6783 91.4144 62.7276C91.2212 62.7769 91.0554 62.9009 90.9536 63.0724L91.6003 63.4563ZM89.0145 67.8129L88.4336 68.2905C88.5893 68.4798 88.8274 68.5814 89.0718 68.5628C89.3162 68.5441 89.5361 68.4075 89.6612 68.1967L89.0145 67.8129ZM88.5593 61.8389L89.206 62.2227L88.5593 61.8389ZM93.4419 59.3L93.385 60.0499C93.67 60.0715 93.9427 59.9296 94.0886 59.6838L93.4419 59.3ZM100.522 47.3708L101.169 47.7546C101.315 47.5088 101.309 47.2015 101.153 46.9616L100.522 47.3708ZM105.228 39.0229L102.806 43.1021L104.1 43.8698L106.521 39.7905L105.228 39.0229ZM103.069 44.1327L106.028 45.8887L106.795 44.5953L103.837 42.8393L103.069 44.1327ZM107.058 45.6258L109.499 41.5142L108.205 40.7466L105.765 44.8581L107.058 45.6258ZM110.027 47.5753C111.369 45.3141 111.045 42.5281 109.422 40.6402L108.282 41.6206C109.497 43.0339 109.736 45.1182 108.734 46.8076L110.027 47.5753ZM104.441 50.4802C106.629 50.6462 108.829 49.5931 110.027 47.5753L108.734 46.8076C107.839 48.3151 106.195 49.1049 104.555 48.9805L104.441 50.4802ZM98.0642 62.0434L105.145 50.1142L103.851 49.3465L96.7708 61.2758L98.0642 62.0434ZM98.1741 67.5456C99.3718 65.5278 99.2423 63.0918 98.0485 61.2505L96.7864 62.0687C97.6813 63.4489 97.7755 65.2704 96.8807 66.7779L98.1741 67.5456ZM91.7968 70.3365C94.2314 70.8568 96.8321 69.8067 98.1741 67.5456L96.8807 66.7779C95.878 68.4673 93.9336 69.2551 92.1111 68.8657L91.7968 70.3365ZM92.6007 69.9849L95.2056 65.5961L93.9122 64.8284L91.3073 69.2173L92.6007 69.9849ZM94.9427 64.5656L91.9841 62.8096L91.2165 64.103L94.175 65.859L94.9427 64.5656ZM90.9536 63.0724L88.3678 67.4291L89.6612 68.1967L92.247 63.8401L90.9536 63.0724ZM87.9126 61.455C86.5939 63.6769 86.8838 66.4053 88.4336 68.2905L89.5954 67.3353C88.4351 65.9238 88.2208 63.8827 89.206 62.2227L87.9126 61.455ZM93.4988 58.5501C91.3106 58.3841 89.1102 59.4372 87.9126 61.455L89.206 62.2227C90.1007 60.7152 91.7449 59.9254 93.385 60.0499L93.4988 58.5501ZM99.8755 46.9869L92.7952 58.9161L94.0886 59.6838L101.169 47.7546L99.8755 46.9869ZM99.7655 41.4848C98.5679 43.5026 98.6973 45.9385 99.8912 47.7799L101.153 46.9616C100.258 45.5815 100.164 43.7599 101.059 42.2524L99.7655 41.4848ZM106.015 38.668C103.618 38.2106 101.084 39.263 99.7655 41.4848L101.059 42.2524C102.044 40.5925 103.938 39.8029 105.733 40.1454L106.015 38.668Z",
    fill: "#2B2B2B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6146 45.4928C32.6152 44.7535 34.0256 44.9653 34.7649 45.9658C50.9217 67.8323 79.1995 67.7315 95.351 54.5684C96.3153 53.7825 97.7342 53.9271 98.5201 54.8915C99.306 55.8558 99.1614 57.2747 98.197 58.0606C80.2604 72.6786 48.9821 72.7882 31.1416 48.643C30.4023 47.6425 30.6141 46.2321 31.6146 45.4928Z",
    fill: "#FF7E3B",
    stroke: "#9E2F00",
    strokeWidth: 1.50407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.f6d1871a7ea828353984da16055dcd91.svg";
export { ForwardRef as ReactComponent };